export default __webpack_public_path__ + "643c8bdd2c6b69f285b4cfb49af150d6.png";